import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { User } from '../../types/user.types';
import { useAppQuery } from '../use-app-query.hook';

export const useUser = () => {
  const queryClient = useQueryClient();

  const { data: user, isLoading } = useAppQuery<User>({
    queryKey: [QueryKey.GET_USER],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.USERS }),
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_USER] });
  }, [queryClient]);

  return {
    isLoading,
    invalidateQuery,
    user,
  };
};
